import { ArticleAppendixVersion, ArticleChangeImportance, ArticleCustomRequirements, ArticleReleaseDetails, ArticleVersionEvaluation, BaseArticleContent, RequirementsStatus, StreamComment } from "..";


export const subscriberArticleActionSorts = [
    '0 - requirements missing',
    '1 - evaluation missing',
    '2 - evaluation recommended',
    '3 - ok'
] as const;
export type SubscriberArticleActionSort = typeof subscriberArticleActionSorts[number];

export type SubscriberArticleContent =
    BaseArticleContent &
    {
        release: ArticleReleaseDetails, // overrides nullable version in BaseArticleContent
        hasEvaluation: boolean;
        publication: {
            wasSubscribed: boolean,
            importance: ArticleChangeImportance,
            changeDescription: string,
            assessment: string,
        },
        owner: { userId:string, displayName:string; initials:string } | null,
        categoryTag: string
    };



export type SubscriberArticle =
    SubscriberArticleContent &
    {
        appendices: ArticleAppendixVersion[],
        evaluation: ArticleVersionEvaluation | null;
        customRequirements: ArticleCustomRequirements | null;
        versionComments: StreamComment[];
    };

export type PublicArticle = Omit<SubscriberArticle, 'versionComments'>;


    
export type SubscriberArticleListing =
    SubscriberArticleContent &
    {
        action:SubscriberArticleActionSort;
        requirementsStatus: RequirementsStatus;
        evaluationImportance: ArticleChangeImportance | null;
        evaluationLastEdited: Date | null;
        openActionPlanCount: number;
    };

export type SubscriberArticlePage = {
    page: number,
    totalItems: number,
    itemsPerPage: number,
    articles: SubscriberArticleListing[];
};

export const SubscriberArticleSorts = [
    'list', 
    'topic', 
    'type', 
    'title', 
    'releaseDate',
    'requirementsStatus', 
    'actionStatus', 
    'importance',
    'evaluationImportance',
    'action',
    'openActionPlans'
] as const;
export type SubscriberArticleSort = typeof SubscriberArticleSorts[number];
export type SubscriberArticleParameters = {
    sortBy?: SubscriberArticleSort,
    sortOrder?: 'asc' | 'desc',
    filter?: {
        typeId?: string,
        topicId?: string,
        listId?: string,
        searchTerm?: string,
        ownerUserId?:string
    };
};

export type InternalSubscriberArticleListing = {
    id:string,
    title:string,
    description:string,
    owner:{ userId:string, displayName:string; initials:string } | null,
    changeId:string,
    version:number,
    date:Date | null,
    evaluationImportance: ArticleChangeImportance | null,
    isDeleted:boolean
}

export type InternalSubscriberArticle = {
    id: string,
    title: string,
    description: string,
    ownerUserId:string | null,
    isDeleted:boolean,
    lastEdited:{ userId:string, date:Date },
    changes: InternalSubscriberArticleChange[]
}

export type InternalSubscriberArticleChange = {
    id:string,
    version:number,
    changeDescription: string,
    date: Date | null,
    evaluation:{
        importance: ArticleChangeImportance | null,
        text:string,
    },
    lastEdited:{ userId:string, date:Date }
}

export type InternalSubscriberArticleView = 
{
    id: string,
    title: string,
    description: string,
    ownerUserId:string | null,
    isDeleted:boolean,

    changeId:string,
    version:number,
    changeDescription:string,
    date: Date | null,
    evaluation:{
        importance: ArticleChangeImportance | null,
        text:string,
    }
    lastEdited:{
        userId:string,
        displayName:string,
        initials:string,
        date:Date
    },
    lastVersionEdited:{
        userId:string,
        displayName:string,
        initials:string,
        date:Date
    }
    previousVersions:InternalSubscriberArticleChangeView[]
}

export type InternalSubscriberArticleChangeView = 
{
    id:string,
    version:number,
    changeDescription: string,
    date: Date | null,
    evaluation:{
        importance: ArticleChangeImportance | null,
        text:string,
    },
    lastEdited:{
        userId:string,
        displayName:string,
        initials:string,
        date:Date
    }
}

export type ArticleListOverview = {
    subscriberId: string,
    siteId: string,
    lists: {
        listId: string,
        listName: string,
        topics: {
            topicId: string,
            topicName: string,
            
            articleCount: number,
            
            articlesWithOwnersCount: number,
            
            articlesWithMissingEvaluationsCount: number,
            articlesWithNeededEvaluationsProvidedCount: number,
            
            articlesWithRequirementsCount: number,
            articlesWithMissingRequirementsCount: number,
            
            articlesEvaluatedLowCount: number,
            articlesEvaluatedHighCount: number,
            articlesEvaluatedMediumCount: number,

            openActionPlanCount: number         
        }[];
    }[];
};